import { Field } from 'formik';
import * as React from 'react';
import SunEditor from 'suneditor-react';
import Turndown from 'turndown';

import { RichTextFieldProps } from './types';
import ErrorMessage from '../ErrorMessage';
import muiStyles from '../fieldStyles';

import 'suneditor/dist/css/suneditor.min.css';

export default function RichTextField(props: RichTextFieldProps) {
    const {
        name,
        label,
        placeholder,
        setFieldValue,
        setFieldTouched,
        initialValue,
        errors
    } = props;

    const classes = muiStyles(props);

    const handleChange = (content) => {
        setFieldTouched(name, true);
        // replace &nbsp; with a space
        let cleanedContent = content.replace(/&nbsp;/gi, ' ');
        if (name === 'Message') {
            const turndownService = new Turndown();
            turndownService
                .addRule('strikethrough', {
                    filter: [ 'del', 's' ],
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    replacement(content) {
                        return `~~  ${content}  ~~`;
                    }
                })
                .addRule('underline', {
                    filter: ['u'],
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    replacement(content) {
                        return `__  ${content}  __`;
                    }
                });

            const markdown = turndownService.turndown(cleanedContent);
            cleanedContent = `${markdown}`;
        }
        setFieldValue(name, cleanedContent);
    };

    const handlePaste = (e) => {
        e.preventDefault();
        let text = '';
        if (e.clipboardData || e.originalEvent.clipboardData) {
            const htmlRegex = /(<([^>]+)>)/ig;
            text = (e.originalEvent || e).clipboardData.getData('text/plain')
                .replace(htmlRegex, '');
        } else {
            return false;
        }

        if (document.queryCommandSupported('insertText')) {
            document.execCommand('insertText', false, text);
        } else {
            document.execCommand('paste', false, text);
        }

        return false;
    };

    return (
        <Field
            name={name}
            type='textarea'
        >
            {({ field, form }) => (
                <div className={classes.field}>
                    <label
                        className={classes.inputLabel}
                        htmlFor={name}
                    >
                        {label}
                    </label>
                    <SunEditor
                        onChange={handleChange}
                        onPaste={handlePaste}
                        placeholder={placeholder || ''}
                        setContents={initialValue}
                        setDefaultStyle='font-family: client-font,sans-serif'
                        setOptions={{
                            maxCharCount: 255,
                            minHeight: '180px',
                            showPathLabel: false,
                            buttonList: [
                                [ 'undo', 'redo' ],
                                [ 'outdent', 'indent', 'list' ],
                                '/', // Line break
                                [ 'bold', 'italic', 'removeFormat' ]
                            ]
                        }}
                    />
                    <ErrorMessage
                        error={errors[field.name]}
                        field={field}
                        form={form}
                    />
                </div>
            )}
        </Field>
    );
}